<template>
  <div class="text-center">
    <div class="text-error">
      <p class="m-0">There was a problem loading the breeds list.</p>
      <p class="m-0">Click this button to try again.</p>
    </div>
    <button class="btn btn-primary btn-sm mt-2" @click.prevent="loadBreeds">
      <i class="fas fa-dog text-smaller-2"></i> Load Breeds
    </button>
    <div v-if="loadBreedsErrorMsg">
      <p class="text-error m-0">
        Could not load breeds. Error: {{ loadBreedsErrorMsg }}
      </p>
      <p class="text-error m-0">Please contact us if the problem continues.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonLoadBreeds',
  data: function () {
    return {
      loadBreedsErrorMsg: '',
    };
  },
  methods: {
    loadBreeds: async function () {
      this.loadBreedsErrorMsg = '';
      try {
        var breedsDocRef = this.$fapi.db.collection('breeds').doc('master');
        var breedsDoc = await breedsDocRef.get();
        var breeds = breedsDoc.data().all;
        this.$store.dispatch('setBreeds', breeds);
        this.$emit('on-click', true);
        // console.log('Breeds', breeds);
      } catch (err) {
        this.$emit('on-click', false);
        this.loadBreedsErrorMsg = err.message;
        // console.error('Error getting breeds list:', err.message);
      }
    },
  },
};
</script>

<style>
</style>